<!--
 * @Author: 月魂
 * @Date: 2021-02-01 09:35:34
 * @LastEditTime: 2022-01-26 15:20:11
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\Visit.vue
-->
<template>
  <div class="box">
    <Header title="visit" />
    <!-- 弹出视频 -->
    <van-overlay v-if="show" :show="show" @click="show = false">
      <div class="wrapper">
        <video
          src="http://image.wearetogether.com.cn/visit-fir.mp4"
          poster="http://cdn.topartsintermational.com/visit-video-bg-ser.jpg"
          controls
          width="100%"
          style="display: block; width: 100%; object-fit: fill"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <van-overlay v-if="visible" :show="visible" @click="visible = false">
      <div class="wrapper">
        <video
          :src="link.link"
          :poster="link.poster"
          controls
          width="100%"
          style="display: block; width: 100%; object-fit: fill"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <img src="http://image.wearetogether.com.cn/visit-ukraine.jpg" width="100%" />
    <div class="part part1">
      <div class="title">{{ setting.part1.title }}</div>
      <p class="des">{{ setting.part1.des }}</p>
      <p class="cont">{{ setting.part1.cont1 }}</p>
      <img
        :src="setting.item.url"
        width="100%"
        style="margin-top: 16px"
        @click="handleVisible(setting.item)"
      />
      <div class="picList">
        <div class="item">
          <img
            src="http://cdn.topartsintermational.com/visit-3-s.jpg"
            width="100%"
          />
        </div>
        <div class="item">
          <img
            src="http://cdn.topartsintermational.com/visit-4-s.jpg"
            width="100%"
          />
        </div>
        <div class="item">
          <img
            src="http://cdn.topartsintermational.com/visit-5-s.jpg"
            width="100%"
          />
        </div>
        <div class="item">
          <img
            src="http://cdn.topartsintermational.com/visit-6-s.jpg"
            width="100%"
          />
        </div>
      </div>
      <img
        src="http://cdn.topartsintermational.com/visit-7.jpg"
        class="horse"
      />
      <div class="horse-cont">
        <p>{{ setting.part1.cont2 }}</p>
      </div>
      <div class="threePic">
        <div class="left">
          <div class="left-item">
            <img
              :src="setting.item1.left1.url"
              width="100%"
              height="100%"
              @click="handleVisible(setting.item1.left1)"
            />
          </div>
          <div class="left-item">
            <img
              :src="setting.item1.left2.url"
              width="100%"
              height="100%"
              @click="handleVisible(setting.item1.left2)"
            />
          </div>
        </div>
        <div class="right">
          <img
            :src="setting.item1.right.url"
            width="100%"
            height="100%"
            @click="handleVisible(setting.item1.right)"
          />
        </div>
      </div>
      <div class="part1-three">
        <div class="three-item" v-for="item in setting.list1" :key="item.id">
          <img :src="item.url" width="100%" @click="handleVisible(item)" />
        </div>
      </div>
    </div>
    <div class="part part2">
      <div class="title">{{ setting.part2.title }}</div>
      <img
        src="http://cdn.topartsintermational.com/visit-14.jpg"
        width="100%"
      />
      <div class="part-wall">
        <div
          class="part-wall-item"
          v-for="item in setting.list2"
          :key="item.id"
        >
          <img
            :src="item.url"
            width="100%"
            height="100%"
            @click="handleVisible(item)"
          />
        </div>
      </div>
    </div>
    <div class="part part3">
      <div class="title">{{ setting.part3.title }}</div>
      <p class="des">{{ setting.part3.des }}</p>
      <p class="part3-cont">
        {{ setting.part3.cont }}
      </p>
      <div class="part-wall">
        <div
          class="part-wall-item"
          v-for="item in setting.list3"
          :key="item.id"
        >
          <img :src="item.url" width="100%" @click="handleVisible(item)" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
export default {
  name: 'Visit',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      setting: {
        part1: {
          title: this.$t('message.visit.part1.title'),
          des: this.$t('message.visit.part1.des'),
          cont1: this.$t('message.visit.part1.cont1'),
          cont2: this.$t('message.visit.part1.cont2'),
        },
        part2: {
          title: this.$t('message.visit.part2.title'),
        },
        part3: {
          title: this.$t('message.visit.part3.title'),
          des: this.$t('message.visit.part3.des'),
          cont: this.$t('message.visit.part3.cont'),
        },
        item: {
          url: 'http://cdn.topartsintermational.com//visit-2.jpg',
          link: 'http://cdn.topartsintermational.com/visit-1.mp4',
          poster: 'http://cdn.topartsintermational.com/visit-2-bg.jpg'
        },
        item1: {
          left1: {
            url: 'http://cdn.topartsintermational.com/visit-8.jpg',
            link: 'http://cdn.topartsintermational.com/visit-2.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-8-bg.jpg'
          },
          left2: {
            url: 'http://cdn.topartsintermational.com/visit-10.jpg',
            link: 'http://cdn.topartsintermational.com/visit-3.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-10-bg.jpg'
          },
          right: {
            url: 'http://cdn.topartsintermational.com/visit-9.jpg',
            link: 'http://cdn.topartsintermational.com/visit-4.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-10-bg.jpg'
          },
        },
        list1: [
          {
            id: 1,
            url: 'http://cdn.topartsintermational.com/visit-11.jpg',
            link: 'http://cdn.topartsintermational.com/visit-5.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-11-bg.jpg'
          },
          {
            id: 2,
            url: 'http://cdn.topartsintermational.com/visit-12.jpg',
            link: 'http://cdn.topartsintermational.com/visit-6.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-12-bg.jpg'
          },
          {
            id: 3,
            url: 'http://cdn.topartsintermational.com/visit-13.jpg',
            link: 'http://cdn.topartsintermational.com/visit-7.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-13-bg.jpg'
          }
        ],
        list2: [
          {
            id: 1,
            url: 'http://cdn.topartsintermational.com/visit-15.jpg',
            link: 'http://cdn.topartsintermational.com/visit-8.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 2,
            url: 'http://cdn.topartsintermational.com/visit-16.jpg',
            link: 'http://image.wearetogether.com.cn/visit-9.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 3,
            url: 'http://cdn.topartsintermational.com/visit-17.jpg',
            link: 'http://image.wearetogether.com.cn/visit-10.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 4,
            url: 'http://cdn.topartsintermational.com/visit-18.jpg',
            link: 'http://image.wearetogether.com.cn/visit-11.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 5,
            url: 'http://cdn.topartsintermational.com/visit-19.jpg',
            link: 'http://image.wearetogether.com.cn/visit-12.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 6,
            url: 'http://cdn.topartsintermational.com/visit-20.jpg',
            link: 'http://image.wearetogether.com.cn/visit-13.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 7,
            url: 'http://cdn.topartsintermational.com/visit-21.jpg',
            link: 'http://cdn.topartsintermational.com/visit-14.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          },
          {
            id: 8,
            url: 'http://cdn.topartsintermational.com/visit-22.jpg',
            link: 'http://cdn.topartsintermational.com/visit-15.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-14-bg.jpg'
          }
        ],
        list3: [
          {
            id: 1,
            url: 'http://cdn.topartsintermational.com/visit-24-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-16.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-24-s-bg.jpg'
          },
          {
            id: 2,
            url: 'http://cdn.topartsintermational.com/visit-25-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-17.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-25-s-bg.jpg'
          },
          {
            id: 3,
            url: 'http://cdn.topartsintermational.com/visit-26-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-18.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-26-s-bg.jpg'
          },
          {
            id: 4,
            url: 'http://cdn.topartsintermational.com/visit-27-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-19.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-27-s-bg.jpg'
          },
          {
            id: 5,
            url: 'http://cdn.topartsintermational.com/visit-28-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-20.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-28-s-bg.jpg'
          },
          {
            id: 6,
            url: 'http://cdn.topartsintermational.com/visit-29-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-21.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-29-s-bg.jpg'
          },
          {
            id: 7,
            url: 'http://cdn.topartsintermational.com/visit-30-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-22.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-30-s-bg.jpg'
          },
          {
            id: 8,
            url: 'http://cdn.topartsintermational.com/visit-31-s.jpg',
            link: 'http://cdn.topartsintermational.com/visit-23.mp4',
            poster: 'http://cdn.topartsintermational.com/visit-31-s-bg.jpg'
          }
        ],
      },
      show: true,
      visible: false,
      link: '',
    }
  },
  methods: {
    handleVisible (item) {
      this.visible = true
      this.link = item
    }
  }
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  min-height: 100vh;
  background: url("http://cdn.topartsintermational.com/visit-bg.jpg") no-repeat;
  background-size: cover;
  .part {
    margin: auto;
    color: #fff;
    text-align: center;
    line-height: 1.8;
    .cont {
      padding: 0 10px;
      text-indent: 2em;
      line-height: 1.8;
      text-align: justify;
    }
    .part-wall {
      margin-top: 16px;
      width: 100%;
      display: flex;
      overflow-x: auto;
      .part-wall-item {
        flex: none;
        width: 47%;
        margin-right: 8px;
        overflow: hidden;
        &:nth-child(8) {
          margin: 0;
        }
      }
    }
  }
  .picList {
    width: 100%;
    padding: 0 10px;
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      width: 49%;
    }
  }
  .horse {
    width: 100%;
    margin-top: 16px;
  }
  .horse-cont {
    background: url("http://cdn.topartsintermational.com/warriors-img2.jpg")
      no-repeat;
    background-size: cover;
    text-indent: 2em;
    line-height: 1.8;
    padding: 10px 10px 0;
    text-align: justify;
  }
  .threePic {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    .left {
      width: 49%;
      display: flex;
      flex-wrap: wrap;
      .left-item {
        &:nth-child(2) {
          margin-top: 16px;
        }
        overflow: hidden;
      }
    }
    .right {
      width: 49%;
      overflow: hidden;
    }
  }
  .part1-three {
    display: flex;
    overflow-x: auto;
    width: 100%;
    margin-top: 16px;
    .three-item {
      flex: none;
      width: 50%;
      margin-right: 8px;
      overflow: hidden;
      &:nth-child(3) {
        margin: 0;
      }
    }
  }
  .part2 {
    margin-top: 16px;
  }
  .part3 {
    margin: 16px 0;
    .part3-cont {
      margin-top: 16px;
      width: 100%;
      background: url("http://cdn.topartsintermational.com/visit-23.jpg")
        no-repeat;
      background-size: cover;
      text-align: justify;
      padding: 8px 10px;
      p {
        text-indent: 2em;
        line-height: 1.8;
        text-align: justify;
        box-sizing: border-box;
        padding: 10px 10px 0;
      }
    }
  }
}
</style>